'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.selectIsMobile = exports.selectViewportScreenSizeSelector = exports.selectViewportScreenSizeAndOrientation = undefined;

var _reselect = require('reselect');

var _constants = require('../../components/constants');

var selectViewportScreenSize = function selectViewportScreenSize(state) {
    return state.viewport.screenSize;
};

var selectViewportOrientation = function selectViewportOrientation(state) {
    return state.viewport.orientation;
};

var selectViewportScreenSizeAndOrientation = exports.selectViewportScreenSizeAndOrientation = (0, _reselect.createSelector)(selectViewportScreenSize, selectViewportOrientation, function (screenSize, orientation) {
    return { screenSize: screenSize, orientation: orientation };
});

var selectViewportScreenSizeSelector = exports.selectViewportScreenSizeSelector = (0, _reselect.createSelector)([selectViewportScreenSize], function (screenSize) {
    return screenSize;
});

var selectIsMobile = exports.selectIsMobile = (0, _reselect.createSelector)(selectViewportScreenSize, function (screenSize) {
    return [_constants.BREAKPOINTS.MOBILE_XS.name, _constants.BREAKPOINTS.MOBILE.name, _constants.BREAKPOINTS.TABLET.name].includes(screenSize);
});